export default __webpack_public_path__ + "static/media/KZ.T.03.1470.e813f1e0.svg";